/* @flow */

import * as React from 'react';
import { Form, Formik } from 'formik';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import PrimaryButton from 'src/shared/ui/component/button/PrimaryButton';

import FormBuilderField from './FormBuilderField';

import styles from './FormBuilder.style';
import messages from './l10n/formBuilderL10n';

import type { FieldData } from './type/formBuilderTypes';
import type { FormikHelpers } from 'formik';
import { useIntl } from 'react-intl';

const useStyles = createUseThemeStyles(styles);

type Props = {
  fieldsData?: Array<FieldData>,
  onSubmit: (Object, FormikHelpers<Object>) => void,
};

const FormBuilder = ({ fieldsData, onSubmit }: Props): React.Node => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <>
      <Formik initialValues={{}} onSubmit={onSubmit}>
        {({ isSubmitting }) => (
          <Form className={classes.form}>
            {fieldsData?.map((field) => (
              <div key={field.key}>
                <FormBuilderField
                  name={field.key}
                  field={field}
                  type={field.field_type}
                />
              </div>
            ))}

            <div className={classes.actions}>
              <PrimaryButton isSubmitting={isSubmitting}>
                {intl.formatMessage(messages.submitBtn)}
              </PrimaryButton>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default React.memo<Props>(FormBuilder);
